import axiosInstance from '@/service/helpers/axios'
import { type AxiosResponse } from 'axios'

export async function getTotalVerifiedUser(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user/total-verified')
  return result
}
export async function getTotalPublishedResearch(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/algo-research/total-published')
  return result
}
export async function getTotalPublishedInsight(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/algo-news/total-published')
  return result
}
export async function getTotalViewSignedInUserForResearchInSevenDaysBack(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-research/seven-days/user')
  return result
}
export async function getTotalViewNonMemberForResearchInSevenDaysBack(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-research/seven-days/nonuser')
  return result
}
export async function getTotalViewSignedInUserForInsightInSevenDaysBack(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-news/seven-days/user')
  return result
}
export async function getTotalViewNonMemberForInsightInSevenDaysBack(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-news/seven-days/nonuser')
  return result
}
export async function getTotalViewSignedInUserForResearchMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-research/monthly/user')
  return result
}
export async function getTotalViewNonMemberForResearchMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-research/monthly/nonuser')
  return result
}
export async function getTotalViewSignedInUserForInsightMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-news/monthly/user')
  return result
}
export async function getTotalViewNonMemberForInsightYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-news/yearly/nonuser')
  return result
}
export async function getTotalViewSignedInUserForResearchYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-research/yearly/user')
  return result
}
export async function getTotalViewNonMemberForResearchYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-research/yearly/nonuser')
  return result
}
export async function getTotalViewSignedInUserForInsightYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-news/yearly/user')
  return result
}
export async function getTotalViewNonMemberForInsightMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/algo-news/monthly/nonuser')
  return result
}

// GET CACHED ANALYTIC
// RESEARCH
export async function getCachedGuestViewResearchSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/ALGORESEARCH/SEVENDAY/GUEST')
  return result
}
export async function getCachedUserViewResearchSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/ALGORESEARCH/SEVENDAY/USER')
  return result
}
export async function getCachedGuestViewResearchMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/ALGORESEARCH/MONTHLY/GUEST')
  return result
}
export async function getCachedUserViewResearchMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/ALGORESEARCH/MONTHLY/USER')
  return result
}
export async function getCachedGuestViewResearchYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/ALGORESEARCH/YEARLY/GUEST')
  return result
}
export async function getCachedUserViewResearchYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/ALGORESEARCH/YEARLY/USER')
  return result
}
// INSIGHT
export async function getCachedGuestViewInsightSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSIGHT/SEVENDAY/GUEST')
  return result
}
export async function getCachedUserViewInsightSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSIGHT/SEVENDAY/USER')
  return result
}
export async function getCachedGuestViewInsightMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSIGHT/MONTHLY/GUEST')
  return result
}
export async function getCachedUserViewInsightMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSIGHT/MONTHLY/USER')
  return result
}
export async function getCachedGuestViewInsightYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSIGHT/YEARLY/GUEST')
  return result
}
export async function getCachedUserViewInsightYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSIGHT/YEARLY/USER')
  return result
}
// INSTITUTION
export async function getCachedGuestViewInstitutionSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSTITUTION/SEVENDAY/GUEST')
  return result
}
export async function getCachedUserViewInstitutionSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSTITUTION/SEVENDAY/USER')
  return result
}
export async function getCachedGuestViewInstitutionMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSTITUTION/MONTHLY/GUEST')
  return result
}
export async function getCachedUserViewInstitutionMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSTITUTION/MONTHLY/USER')
  return result
}
export async function getCachedGuestViewInstitutionYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSTITUTION/YEARLY/GUEST')
  return result
}
export async function getCachedUserViewInstitutionYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/INSTITUTION/YEARLY/USER')
  return result
}

// CIRCLE
export async function getCachedGuestViewCircleSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/CIRCLE/SEVENDAY/GUEST')
  return result
}
export async function getCachedUserViewCircleSevenDay(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/CIRCLE/SEVENDAY/USER')
  return result
}
export async function getCachedGuestViewCircleMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/CIRCLE/MONTHLY/GUEST')
  return result
}
export async function getCachedUserViewCircleMonthly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/CIRCLE/MONTHLY/USER')
  return result
}
export async function getCachedGuestViewCircleYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/CIRCLE/YEARLY/GUEST')
  return result
}
export async function getCachedUserViewCircleYearly(): Promise<AxiosResponse> {
  const result = await axiosInstance.get('/analytic/user-behaviour/cached-analytic/data/CIRCLE/YEARLY/USER')
  return result
}